import { render, staticRenderFns } from "./CarPreferredVendors.vue?vue&type=template&id=67af7718&"
import script from "./CarPreferredVendors.vue?vue&type=script&lang=js&"
export * from "./CarPreferredVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports